<div class="report-box">
  <h1 class="text-center">Host Statistics Report</h1>
  <h3 class="text-center">Download a CSV file with aggregated statistics for all active Hosts. Available stats are games hosted, number of venues hosted at, Player feedback score and last hosting date</h3>
  <h2 *ngIf="loading">Generating Report. This could take a moment...</h2>
  <p class="error-message" *ngIf="err">{{err}}</p>

  <div *ngIf="!loading" class="hrz-center">
    <button class="sm-btn-red" [disabled]="!statsObject" (click)="downloadStats()">Download</button>
  </div>
</div>
